import { defineStore } from 'pinia'


const useUserStore = defineStore('user', {
  state: () => ({
    token: '',
    userInfo: {} as Record<string, any>
  }),
  actions: {
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo: Record<string, unknown>) {
      this.userInfo = userInfo
    },
    clearCache() {
      this.token = ''
      this.userInfo = {}
    }
  },
  persist: true
})

export default useUserStore
